/* Body copy reveals paragraph by paragraph, with a separate queue per section. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)) { return; }
  var queues = new WeakMap();
  var completions = new WeakMap();
  var HEADING_SHARE = 0.75;   /* copy starts once the heading is this far written */
  // Earliest start for copy below a letter-revealed heading (riivah-heading-reveal.js).
  function headingGate(section, paragraph, now) {
    var heading = section && section.querySelector('h2.riivah-lp-heading-letters');
    if (!heading || !(heading.compareDocumentPosition(paragraph) & Node.DOCUMENT_POSITION_FOLLOWING)) { return 0; }
    var letters = heading.querySelectorAll('.riivah-lp-heading-letter');
    if (!letters.length) { return 0; }
    // A heading with a handwritten script word reports its own total; otherwise
    // read the last letter's fade (computed delay and duration are in seconds).
    var last = getComputedStyle(letters[letters.length - 1]);
    var total = heading.riivahLettersTotal ||
      (parseFloat(last.transitionDelay) + parseFloat(last.transitionDuration)) * 1000;
    return (heading.riivahLettersStart || now) + total * HEADING_SHARE;
  }
  function reveal(paragraph) {
    if (completions.has(paragraph)) { return completions.get(paragraph); }
    var section = paragraph.closest('section');
    var now = performance.now();
    var start = Math.max(now, queues.get(section) || 0, headingGate(section, paragraph, now));
    paragraph.style.setProperty('--riivah-paragraph-delay', (start - now) + 'ms');
    var completed = new Promise(function (resolve) {
      function finish() {
        paragraph.removeEventListener('transitionend', onEnd);
        clearTimeout(fallback);
        resolve();
      }
      function onEnd(event) {
        if (event.target === paragraph && event.propertyName === 'opacity') { finish(); }
      }
      paragraph.addEventListener('transitionend', onEnd);
      // A fallback covers background tabs or an interrupted/disabled transition.
      var fallback = setTimeout(finish, start - now + 700);
    });
    completions.set(paragraph, completed);
    paragraph.classList.add('is-paragraph-revealed');
    queues.set(section, start + 650);
    observer.unobserve(paragraph);
    return completed;
  }
  window.RiivahParagraphReveal = {
    before: function (element, callback) {
      var section = element.closest('section');
      var preceding = section ? Array.from(section.querySelectorAll('.riivah-lp-paragraph')).filter(function (paragraph) {
        return !!(paragraph.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING);
      }) : [];
      // If a visitor jumps directly to a lower item, also finish skipped copy.
      Promise.all(preceding.map(reveal)).then(function () {
        if (element.isConnected) { callback(preceding.length > 0); }
      });
    }
  };
  var observer = new IntersectionObserver(function (entries) {
    entries.sort(function (a, b) {
      return a.target.compareDocumentPosition(b.target) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    }).forEach(function (entry) {
      if (entry.isIntersecting) { reveal(entry.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  function initialize(root) {
    root.querySelectorAll('section p.riivah-lp-reveal[class*="-copy"]').forEach(function (copy) {
      var original = copy.innerHTML;
      try {
        var parts = original.split(/((?:<br\s*\/?>\s*){2,})/gi);
        var fragment = document.createDocumentFragment();
        parts.forEach(function (part, index) {
          if (index % 2) { return; }
          var paragraph = document.createElement('span');
          paragraph.className = 'riivah-lp-paragraph';
          if (index > 0) {
            var breaks = parts[index - 1].match(/<br\s*\/?>/gi).length;
            paragraph.style.setProperty('--riivah-paragraph-gap', breaks - 1);
          }
          // Content comes from the already escaped Liquid body copy.
          paragraph.innerHTML = part;
          fragment.appendChild(paragraph);
        });
        copy.replaceChildren(fragment);
        copy.classList.remove('riivah-lp-reveal');
        copy.classList.add('riivah-lp-paragraphs-ready');
        copy.querySelectorAll('.riivah-lp-paragraph').forEach(function (paragraph) {
          observer.observe(paragraph);
        });
      } catch (error) {
        copy.innerHTML = original;
        copy.classList.remove('riivah-lp-paragraphs-ready');
        copy.classList.add('riivah-lp-reveal', 'is-revealed');
      }
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.riivah-lp-paragraph').forEach(function (paragraph) {
      observer.unobserve(paragraph);
    });
  });
})();
